import { render } from "./Mobile.vue?vue&type=template&id=6faaadc7&scoped=true&ts=true"
import script from "./Mobile.vue?vue&type=script&lang=ts"
export * from "./Mobile.vue?vue&type=script&lang=ts"

import "./Mobile.vue?vue&type=style&index=0&id=6faaadc7&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/MoTobi-Web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6faaadc7"]])

export default __exports__